// externals
import type { FC } from 'react';
import { useEffect, useRef } from 'react';

// libraries
import { Button } from '@interstate/components/Button';
import { TrashIcon } from '@interstate/components/Icons/TrashIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import { ArrowUturnLeftIcon as IconHistory } from '@interstate/components/Icons/ArrowUturnLeftIcon';

import { FeeDeleteButtonContainer } from './FinanceDeleteCell.style';

// types
import type { CellFinanceDetailsProps } from './types';
import { useFeesFormContext } from './useFeesFormContext';
import { dealLockHooks } from '@makemydeal/dr-dash-components';

export const FinanceDeleteCell: FC<CellFinanceDetailsProps> = ({ detail, index }) => {
    const { handleDelete, commitFeeSoftSaveDebounced } = useFeesFormContext();
    const deleted = detail.isDeleted || false;
    const prevDeletedState = useRef<boolean>(deleted);
    const isLocked = dealLockHooks.useIsDealLocked();

    useEffect(() => {
        if (prevDeletedState.current !== deleted) {
            prevDeletedState.current = deleted;
            commitFeeSoftSaveDebounced();
        }
    }, [deleted]);

    const handleFeesOverrideItemDeleteOrUndo = () => {
        handleDelete({ index, category: detail.category, code: detail.code ?? 0, isDelete: !deleted });
    };

    return (
        <FeeDeleteButtonContainer>
            <Button
                className="delete-fee-button"
                buttonStyle={'tertiary'}
                id={`edit-fee--delete-cell-${detail.code}`}
                data-testid={`edit-fee--delete-cell-${detail.code}`}
                onClick={handleFeesOverrideItemDeleteOrUndo}
                disabled={isLocked}
            >
                {deleted && (
                    <Tooltip
                        data-testid="tooltip-deleted"
                        toolTipContent="Item was deleted. You can still undo this before updating the Offer."
                        position="bottom"
                        size="small"
                    >
                        <IconHistory />
                    </Tooltip>
                )}
                {!deleted && <TrashIcon data-testid={`manual-rebate-delete-${index}`} className="manual-rebate-delete-icon" />}
            </Button>
        </FeeDeleteButtonContainer>
    );
};
